import { Overlay as Bs5Overlay } from 'react-bootstrap5';

export default Bs5Overlay;
